<app-car-details 
    [businessLine]= businessLine!>

</app-car-details>
